<script setup lang="ts">
import type { EmbedMedia } from '~/models/Strapi'

interface Props {
  datas: EmbedMedia
}

const props = defineProps<Props>()
const { scriptTag, load, unload } = useScriptTag(
  props.datas.embeded_script,
  () => {},
  { manual: true },
)

watch(() => process.client, async (newVal) => {
  if (newVal && props.datas.embeded_script)
    await load()
}, { immediate: true })
</script>

<template>
  <div>
    <h2 v-if="props.datas.title" class="text-2xl font-bold mb-4">
      {{ props.datas.title }}
    </h2>
    <div v-if="props.datas?.content">
      <div v-for="(item, idx) in props.datas?.content" :key="idx" v-html="useArticleHTMLSerializer(item)" />
    </div>
    <div v-if="props.datas.embeded_code" style="width: fit-content;" class="frame-container md:mx-auto mt-2" v-html="props.datas.embeded_code" />
    <p v-if="props.datas?.media_description" class="text-[10px] text-gray-500 mt-1 text-center">
      {{ props.datas?.media_description }}
    </p>
  </div>
</template>

<style scoped>
.frame-container :deep(iframe){
  max-width: 70vw !important
}
</style>
